import React, { useState } from 'react';
import EEFindMyInformation from '../../employeeProfile/components/EEFindMyInformation';
import { Breadcrumbs, Breadcrumb, Heading } from '@digitools/honest-react';
import { useHomePageBreadcrumbs } from 'src/components/Breadcrumbs';
import useExperience from 'src/hooks/useExperience';
import { useTranslation } from 'react-i18next';
const FindMyInfo = () => {
    const [fmiCompleted, setFmiCompleted] = useState(false);
    const { t: translation } = useTranslation('rabTranslation');
    const { language } = useExperience();
    if (fmiCompleted) {
        window.location.assign('/customer/rab/employee');
    }
    return (<div data-testid='findMyInfo'>
      <Breadcrumbs>
        {useHomePageBreadcrumbs()}
        <Breadcrumb>{translation('reportABirthHeaderText').toString()}</Breadcrumb>
      </Breadcrumbs>
      <Heading data-public={true} data-testid='reportABirthHeaderText'>
        {translation('reportABirthHeaderText').toString()}
      </Heading>
      <EEFindMyInformation onComplete={setFmiCompleted} noRedirect={true}/>
    </div>);
};
export default FindMyInfo;
